import { render, staticRenderFns } from "./Nopassword.vue?vue&type=template&id=adfc5e34&scoped=true&"
import script from "./Nopassword.vue?vue&type=script&lang=js&"
export * from "./Nopassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfc5e34",
  null
  
)

export default component.exports